import { toast } from '@/components/ui/toast';

const DEMO_RESTRICTED_CODE = 'demo_restricted';
const DEMO_RESTRICTED_MESSAGE = 'Demo accounts cannot interact with real content';

/**
 * Minimal duck type that covers both ApiError instances and plain objects
 * used in tests. Kept narrow to avoid importing ApiError from client.ts
 * (which would create a circular dependency: client -> demo-restriction -> client).
 */
interface DemoCheckable {
  status: number;
  data?: { error?: { code?: string; message?: string } } | null;
}

/**
 * Inspects an error returned by the API client. When the gateway signals
 * that the requested action is blocked for demo accounts (HTTP 403 with
 * code "demo_restricted", or the well-known demo message as a resilience
 * fallback), displays a friendly toast.
 *
 * The function intentionally does NOT rethrow — callers must still throw
 * the original error so existing error-state handling is unchanged.
 */
export function handleDemoRestricted(error: DemoCheckable): void {
  if (error.status !== 403) {
    return;
  }

  const errorPayload = error.data?.error;
  const isDemoBlock =
    errorPayload?.code === DEMO_RESTRICTED_CODE ||
    errorPayload?.message === DEMO_RESTRICTED_MESSAGE;

  if (!isDemoBlock) {
    return;
  }

  toast.error('Not available in demo mode', {
    description: 'This action uses sample data only.',
  });
}
